<template>
  <v-card>
    <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">Warranty</th>
            <th class="text-left">Range</th>
            <th class="text-left">Available Cells</th>
          </tr>
          <tr class="v-data-table__progress" v-if="loading">
            <th class="column" colspan="5">
              <v-progress-linear
                indeterminate
                color="primary"
                height="2"
              ></v-progress-linear>
            </th>
          </tr>
        </thead>
        <tbody>

          <tr v-for="item in cellsWarrantyList" :key="item.name" :class="item.class">
            <td>{{ item.warranty }}</td>
            <td>{{ item.range.join(" - ") }}</td>
            <td>{{ item.availableCells }}</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </v-card>

</template>

<script>
import services, { balancedcells } from "@/api";
import ranges from "./ranges.json";

export default {
  name: "BalancedSummary",
  props: ['warranties', 'warrantyRanges'],
  data: () => ({
    loading: false,
    cellsPowerList: [],
    cellsWarrantyList: [
      {
        warranty: "2 Years",
        range: ranges['2years'],
        balancedCells: 0,
        availableCells: 0,
        unbalancedCells: 0
      },
      {
        warranty: "1 Year",
        range: ranges['1year'],
        balancedCells: 0,
        availableCells: 0,
        unbalancedCells: 0
      },
      {
        warranty: "6 Months",
        range: ranges['6months'],
        balancedCells: 0,
        availableCells: 0,
        unbalancedCells: 0
      },
      {
        warranty: "45 Days",
        range: [],
      },
      {
        warranty: "Grade A",
        range: ranges['45days_A'],
        balancedCells: 0,
        availableCells: 0,
        unbalancedCells: 0,
        class: 'grouped-cell' 
      },
      {
        warranty: "Grade B",
        range: ranges['45days_B'],
        balancedCells: 0,
        availableCells: 0,
        unbalancedCells: 0,
        class: 'grouped-cell' 
      },
      {
        warranty: "Grade C",
        range: ranges['45days_C'],
        balancedCells: 0,
        availableCells: 0,
        unbalancedCells: 0,
        class: 'grouped-cell' 
      },
      {
        warranty: "Grade D",
        range: ranges['45days_D'],
        balancedCells: 0,
        availableCells: 0,
        unbalancedCells: 0,
        class: 'grouped-cell' 
      },
      {
        warranty: "45 Days (Total)",
        range: ranges['45days'],
        balancedCells: 0,
        availableCells: 0,
        unbalancedCells: 0,
        class: 'grouped-footer' 
      },
      {
        warranty: "Others",
        range: ranges['others'],
        balancedCells: 0,
        availableCells: 0,
        unbalancedCells: 0
      },
      {
        warranty: "Total",
        range: [ranges['others'][0], ranges['1year'][1]],
        balancedCells: 0,
        availableCells: 0,
        unbalancedCells: 0
      }
    ],
  }),
  methods: {
    initialize () {
      this.getSummary();
    },

    async getSummary() {
      this.loading = true;
      // initialize api request
      let balancedCellsSummary = balancedcells.summary();
      let availableCellsSummary = services.getCellsListCount();

      // resolve api request
      balancedCellsSummary = await balancedCellsSummary;
      availableCellsSummary = await availableCellsSummary;

      const balancedCells = this.$clone(balancedCellsSummary.data);
      balancedCells.forEach((v) => {
        this.cellsWarrantyList.forEach((w) => {
          if(this.between(v.range, w.range[0], w.range[1])) {
            w.balancedCells += v.count;
          }
        })
      });

      const availableCells = this.$clone(availableCellsSummary.data);
      availableCells.forEach((v) => {
        this.cellsWarrantyList.forEach((w) => {
          if(this.between(v.range, w.range[0], w.range[1])) {
            w.availableCells += v.count;
            w.unbalancedCells += v.notbalanced;
          }
        })
      });

      this.cellsPowerList = balancedCellsSummary.data;
      this.loading = false;
    },
  },
  mounted() {
    this.initialize();
  }
};
</script>
<style>
/* .grouped-cell td{
} */
.grouped-cell td:first-child{
  font-size: 11px;
  padding-left: 40px;
}
.grouped-footer td{
  font-weight: bold;
}
.grouped-footer td:first-child {
  font-size: 11px;
  padding-left: 40px;
}

</style>